import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "error-message"
}

import { useBookings } from '@/composables/useBookings'
  import { useI18n } from 'vue-i18n'

  // VUE Components
  import ReservationsSkeleton from '@/components/ConfirmedReservations/ReservationsSkeleton.vue'
  import ViewWrapper from '@/components/UI/ViewWrapper.vue'
  import BookingList from '@/components/common/BookingList.vue'
  import PastBookingsList from '@/components/ConfirmedReservations/PastBookingsList.vue'
  import { computed, onMounted } from 'vue'
  import store from '@/store'

  // Translations
  
export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmedReservationsView',
  setup(__props) {

  const { t } = useI18n()

  // Bookings Map
  const bookingsMap = {
    currentBookings: computed(() => store.getters['booking/currentBookings']),
    pastBookings: computed(() => store.getters['booking/pastBookings']),
  }

  const {
    isLoading,
    error,
    updatedBookings,
    fetchAndMapBookings,
    openPanelByRef,
  } = useBookings(bookingsMap)

  onMounted(async () => {
    await fetchAndMapBookings()
    openPanelByRef()
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ViewWrapper, {
    id: "confirmed-reservations",
    title: _unref(t)('reservations.pageTitle'),
    class: "w-100"
  }, {
    default: _withCtx(() => [
      (_unref(isLoading))
        ? (_openBlock(), _createBlock(ReservationsSkeleton, { key: 0 }))
        : (_unref(error))
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_unref(t)('errorMessages.fetchBookings')), 1))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(BookingList, {
                bookings: _unref(updatedBookings).currentBookings.value
              }, null, 8, ["bookings"]),
              (_unref(updatedBookings).pastBookings.value.length)
                ? (_openBlock(), _createBlock(PastBookingsList, {
                    key: 0,
                    bookings: _unref(updatedBookings).pastBookings.value
                  }, null, 8, ["bookings"]))
                : _createCommentVNode("", true)
            ], 64))
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})